namespace $ {
	
	export var $mol_dom_context : Window & {
		Node : typeof Node
		Element : typeof Element
		HTMLElement : typeof HTMLElement
		XMLHttpRequest : typeof XMLHttpRequest
	}
	
}
